// extracted by mini-css-extract-plugin
export var deleteIcon = "_s6-5";
export var deleteOption = "_s6-3";
export var divider = "_s6-2";
export var downloadIcon = "_s6-4";
export var drawer = "_s6-0";
export var drawerFooter = "_s6-6";
export var drawerOpen = "_s6-1";
export var highlighted = "_s6-7";
export var lighterHighlight = "_s6-8";